import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    width: 560,
    maxWidth: "calc(100vw - 48px)",
    padding: 32,
    borderRadius: 12,
    background: theme.palette.background.paper,
    outline: "none",
  },
  title: {
    display: "block",
    marginBottom: 16,
    fontSize: 26,
    fontWeight: 700,
  },
  message: {
    display: "block",
    marginBottom: 28,
    fontSize: 18,
    lineHeight: 1.5,
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 12,
  },
}));
